import { render, staticRenderFns } from "./StatisticsCardHorizontal.vue?vue&type=template&id=bbb1af64&scoped=true&"
import script from "./StatisticsCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardHorizontal.vue?vue&type=style&index=0&id=bbb1af64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb1af64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VIcon})
